import React, { useState, FC } from 'react';

import { JRadioProps } from './../../models';
import { JRadioGroup } from './../../../JForm/JRadioGroup';
import { GenericRadioContainer } from './GenericRadioContainer';

export const JRadio: FC<JRadioProps> = (props) => {
    const [radio, setRadio] = useState<string>(props.value as string || '');
    return (
        <GenericRadioContainer 
            {...props} 
            className={props.style === 'BUTTON' ? 'jradio-button-style' : 'jradio-circle-style'}
        >
            {!!props.overrideValue && props.overrideValue !== null
                ? <></>
                : <JRadioGroup
                name={props.fieldKey}
                elements={props.options}
                style={props.style}
                direction="horizontal"
                disabled={props.disabled}
                radioValue={radio}
                onChange={(e) => setRadio(e.target.value)}
                errorMessage={props.validationMessage}
            />}
        </GenericRadioContainer>
    )
}